import React, { FC } from 'react';
import { View } from 'react-native';
import { DailyHeader } from '@components';

import { DailyForecastData } from '@store';

import { styles } from './styles';

type DailyWeatherTopRowProps = {
  data: DailyForecastData;
  index: number;
  nextFocusDown: number | null;
  defaultFocus: number | null;
};

export const DailyWeatherTopRow: FC<DailyWeatherTopRowProps> = ({ data, index, nextFocusDown, defaultFocus }) => (
  <View style={styles.topRowWrapper}>
    <View style={styles.rowWrapper}>
      <DailyHeader data={data} defaultFocus={defaultFocus} index={index} nextFocusDown={nextFocusDown} />
    </View>
  </View>
);
